import { useState, useEffect } from 'react';
import { getClosedInvestments } from '../services/apiGateway';

function useClosedInvestments(setLoading) {
  const [closedInvestments, setClosedInvestments] = useState([]);

  useEffect(() => {
    const abortController = new AbortController();
    let ignore = false;

    async function fetchData() {
      const response = await getClosedInvestments();
      setClosedInvestments(response);
      if (setLoading) {
        setLoading(false);
      }
    }

    fetchData();

    return () => {
      ignore = true;
      abortController.abort();
    };
  }, []);

  return closedInvestments;
}

export default useClosedInvestments;
